// Story 7.30 (ADO-1112), AC1 — the leaflet collection's canonical destination.
//
// The collection is NOT a second screen: it is `/products` under one offer filter, so the
// Shopper's Range, their Trading Account's prices, stock and the Add button are the ones they
// already use, and they order from the collection without leaving it. Defining the href once
// keeps every entry point (landing page, filter rail, a shared link) on the same URL.
import { PRODUCTS_ROUTE } from '../../ordering/orderingChoices';

/** The server offer kind a Leaflet Line carries (`OfferKindDto.LEAFLET_LINE`). */
export const LEAFLET_LINE_KIND = 'LEAFLET_LINE';

/** `/products?offerType=LEAFLET_LINE` — this cycle's leaflet lines, for the active account. */
export const LEAFLET_LINES_ROUTE = `${PRODUCTS_ROUTE}?offerType=${LEAFLET_LINE_KIND}`;
